






















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import Toggle from '@/views/document/section/Toggle.vue';

@Component({components: {Toggle}})
export default class Cashflow extends Vue {
  @Prop() readonly group!: any;

  selectedMethod: any = {};
  selectedRecommendation: any = {};

  @Watch('group', {immediate: true, deep: true})
  onGroup() {
    switch (this.group.Method) {
      case 'complete':
        this.selectedMethod = this.methodItems[2];
        break;
      case 'compact':
        this.selectedMethod = this.methodItems[1];
        break;
      default:
        this.selectedMethod = this.methodItems[0];
        break;
    }

    switch (this.sectionRecommendation.SubType) {
      case 'cashflowRecommendation_financing':
        this.selectedRecommendation = this.recomendationItems[4];
        break;
      case 'cashflowRecommendation_investments':
        this.selectedRecommendation = this.recomendationItems[3];
        break;
      case 'cashflowRecommendation_workingcapital':
        this.selectedRecommendation = this.recomendationItems[2];
        break;
      case 'cashflowRecommendation_daytoday':
        this.selectedRecommendation = this.recomendationItems[1];
        break;
      default:
        this.selectedRecommendation = this.recomendationItems[0];
    }

    this.update();
  }

  @Watch('selectedMethod', {immediate: false, deep: true})
  selectedMethodChanged() {
    this.update();
  }

  @Watch('selectedRecommendation', {immediate: false, deep: true})
  selectedRecommendationChanged() {
    this.update();
  }

  @Watch('section0', {immediate: false, deep: true})
  onData0() {
    this.update();
  }

  @Watch('section1', {immediate: false, deep: true})
  onData1() {
    this.update();
  }

  @Watch('section2', {immediate: false, deep: true})
  onData2() {
    this.update();
  }

  @Watch('section3', {immediate: false, deep: true})
  onData3() {
    this.update();
  }

  update() {
    if (this.recommendationHasChanges) {
      this.updateSection();
      this.updateGroup();
    } else if (this.groupHasChanges) {
      this.updateGroup();
    }
  }

  updateSection() {
      const section = this.sectionRecommendation;
      const s = {
        Id: section.Id,
        Kind: section.Kind,
        Type: section.Type,
        SubType: this.selectedRecommendation.id,
      };
      dokument.updateItem(s);
  }

  updateGroup() {
      let children = [1000];
      if (this.selectedMethod.id === 'complete') {
        children = children.concat([1001, 1002, 1003, 1004, 1005, 1006, 1007]);
      } else if (this.selectedMethod.id === 'compact') {
        children = children.concat([1001, 1002, 1003]);
      }
      children = children.concat([2002, 2003, 2004, 2005]);
      if (this.sectionRecommendation.SubType !== 'cashflowRecommendation_none') {
        children = children.concat([2007]);
      }

      const g = {
        Id: this.group.Id,
        Kind: this.group.Kind,
        Type: this.group.Type,
        SubType: this.group.SubType,
        Children: children,
        Recommendation: this.selectedRecommendation.id,
        Method: this.selectedMethod.id,
        Hidden: this.hidden,
      };
      dokument.updateItem(g);
  }

  get groupHasChanges() {
    return this.group.Hidden !== this.hidden ||
        this.group.Method !== this.selectedMethod.id ||
        this.recommendationHasChanges;
  }

  get recommendationHasChanges() {
    return this.sectionRecommendation.SubType !== this.selectedRecommendation.id;
  }

  get section0(): any {
    return dokument.getItem(2002);
  }

  get section1(): any {
    return dokument.getItem(2003);
  }

  get section2(): any {
    return dokument.getItem(2004);
  }

  get section3(): any {
    return dokument.getItem(2005);
  }

  get sectionRecommendation(): any {
    return dokument.getItem(2007);
  }

  get hidden(): boolean {
    return this.section1.Hidden === true && this.section2.Hidden === true &&
        this.section3.Hidden === true && this.section0.Hidden === true &&
        this.selectedMethod.id === 'none' && this.selectedRecommendation.id === 'cashflowRecommendation_none';
  }

  get methodItems() {
    return [
      {
        id: 'none',
        label: 'Visa ingen metodik',
      },
      {
        id: 'compact',
        label: 'Visa kompakt metodik (3 slides)',
      },
      {
        id: 'complete',
        label: 'Visa komplett metodik (7 slides)',
      },
    ];
  }

  get recomendationItems() {
    return [
      {
        id: 'cashflowRecommendation_none',
        label: 'Ingen rekommendation lämnas',
      },
      {
        id: 'cashflowRecommendation_daytoday',
        label: 'Fokus på operativ verksamhet',
      },
      {
        id: 'cashflowRecommendation_workingcapital',
        label: 'Fokus på bolagets rörelsekapital',
      },
      {
        id: 'cashflowRecommendation_investments',
        label: 'Fokus på bolagets investeringar',
      },
      {
        id: 'cashflowRecommendation_financing',
        label: 'Fokus på bolagets finansiering',
      },
    ];
  }
}
